import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import style from "../../styles/grid.module.css";
const url = process.env.REACT_APP_URL_DIR + "sqlraw/sql";

function getToday() {
   const d = new Date();
   return d.toISOString().slice(0, 10);
}
function getFirstDayOfMonth() {
   const d = new Date();
   d.setDate(1);
   return d.toISOString().slice(0, 10);
}

function formatDateDMY(dateStr) {
   if (!dateStr) return "";
   const d = new Date(dateStr);
   const day = String(d.getDate()).padStart(2, "0");
   const month = String(d.getMonth() + 1).padStart(2, "0");
   const year = d.getFullYear();
   return `${day}/${month}/${year}`;
}

export default function DateRangeForm() {
   const token = localStorage.getItem("token");
   const { register, watch } = useForm({
      defaultValues: {
         startDate: getFirstDayOfMonth(),
         endDate: getToday(),
         detallado: false,
         tipo: "Tattoo", // <-- default for combobox
      },
   });

   const [results, setResults] = useState([]);
   const startDate = watch("startDate");
   const endDate = watch("endDate");
   const detallado = watch("detallado");
   const tipo = watch("tipo");
   
   useEffect(() => {
      console.log('tipo: ', tipo);
      const fetchData = async () => {
         let sql1 = `select i.descripcion,sum(c2.cantidad) Cantidad,sum(c2.precio) Precio `
         sql1 += `from compratattoo c  `
         sql1 += `join compratattooinsumo c2 on c2."compraIdPrimary" = c.id_primary `
         sql1 += `join insumo i on i.id_primary =c2."insumoIdPrimary" `
         sql1 += `where  to_char(c.fecha,'yyyy-mm-dd') >= '${startDate}' `
         sql1 += ` and to_char(c.fecha,'yyyy-mm-dd') <= '${endDate}' `
         sql1 += `group by  i.descripcion`
         if (detallado) {
            sql1 = `select fecha,i.descripcion,c2.cantidad Cantidad,c2.precio Precio `
            sql1 += `from compratattoo c  `
            sql1 += `join compratattooinsumo c2 on c2."compraIdPrimary" = c.id_primary `
            sql1 += `join insumo i on i.id_primary =c2."insumoIdPrimary" `
            sql1 += `where  to_char(c.fecha,'yyyy-mm-dd') >= '${startDate}' `
            sql1 += ` and to_char(c.fecha,'yyyy-mm-dd') <= '${endDate}' `
            sql1 += `order by  i.descripcion`
         }
         if (tipo === "Piercing") {
            sql1 =sql1.replace("compratattoo", "compra")
            sql1 =sql1.replace("compratattooinsumo", "comprainsumo")
         }
         const response = await fetch(`${url}/${sql1}`, {
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });
         const data = await response.json();
         setResults(Array.isArray(data) ? data : [data]);
      };

      if (startDate && endDate) {
         fetchData();
      }
   }, [startDate, endDate, detallado, tipo, token]);

   return (
      <div style={{ maxWidth: 1000, margin: "2rem auto" }}>
         <form style={{ marginBottom: "2rem" }}>
            <div>
               <h2>Compras</h2>
            </div>
            <div className={style.fecha_group}>
               <label className={style.titledate}>
                  Fecha Inicio:&nbsp;
                  <input
                     className={style.inputdate}
                     type="date"
                     {...register("startDate", { required: true })}
                  />
               </label>
               &nbsp;&nbsp;
               <label className={style.titledate}>
                  Fecha Fin:&nbsp;
                  <input
                     className={style.inputdate}
                     type="date"
                     {...register("endDate", { required: true })}
                  />
               </label>
               &nbsp;&nbsp;
               <label
                  style={{
                     display: "inline-flex",
                     alignItems: "center",
                     marginLeft: "1rem",
                  }}
               >
                  <input
                     type="checkbox"
                     {...register("detallado")}
                     style={{ marginRight: "5px" }}
                  />
                  Detallado
               </label>
               &nbsp;&nbsp;
               <label className={style.titledate}>
                  Tipo:&nbsp;
                  <select {...register("tipo")} className={style.inputdate}>
                     {/* <option value="">Todos</option> */}
                     <option value="Piercing">Piercing</option>
                     <option value="Tattoo">Tattoo</option>
                  </select>
               </label>               
            </div>
         </form>
         {results.length > 0 && (
            <table
               border="1"
               cellPadding="8"
               style={{ width: "100%", borderCollapse: "collapse" }}
            >
               <thead>
                  <tr>
                     {detallado ? <th>Fecha</th> : null}
                     <th>Descripción</th>
                     <th>Cantidad</th>
                     <th>Total</th>
                  </tr>
               </thead>
               <tbody>
                  {results.map((item, idx) => (
                     <tr key={idx}>
                        {detallado ? <td>{formatDateDMY(item.fecha)}</td> : null}
                        <td>{item.descripcion}</td>
                        <td className={style.style_precio}>
                           {item.cantidad}&nbsp;
                        </td>
                        <td className={style.style_precio}>
                           ${item.precio}&nbsp;
                        </td>
                     </tr>
                  ))}
               </tbody>
            </table>
         )}
      </div>
   );
}